module.exports = __webpack_public_path__ + "static/media/heart.90047e19.svg";